import { Box } from '@mui/material';
import { useState } from 'react';

const ExpandableList = ({
  items = [],
  maxVisible = 2,
  renderItem,
  emptyText = 'None',
  gap = 0.5,
  expandText,
  collapseText = 'Show less',
}) => {
  const [expanded, setExpanded] = useState(false);

  if (!items?.length) return emptyText;

  const shouldTruncate = items.length > maxVisible;

  const displayedItems =
    expanded || !shouldTruncate ? items : items.slice(0, maxVisible);

  return (
    <Box>
      <Box display="flex" flexDirection="column" gap={gap}>
        {displayedItems.map((item, index) => (
          <Box key={index}>{renderItem ? renderItem(item, index) : item}</Box>
        ))}
      </Box>

      {shouldTruncate && (
        <Box
          component="span"
          onClick={() => setExpanded((prev) => !prev)}
          sx={{
            mt: 0.5,
            display: 'inline-flex',
            alignItems: 'center',
            cursor: 'pointer',
            color: 'primary.main',
            userSelect: 'none',
            transition: 'opacity 0.2s ease',

            '&:hover': {
              opacity: 0.8,
              textDecoration: 'underline',
            },
          }}>
          {expanded
            ? collapseText
            : expandText || `+${items.length - maxVisible} more`}
        </Box>
      )}
    </Box>
  );
};

export default ExpandableList;
